const dataCategories = [
    {
        id: 1,
        nameh1: 'TEXTIL',
        namep: 'ESTILAZOS DE LA TORTUGA',
        url1: 'https://www.hakahonu.cl/textil/mujer.html',
        url2: 'https://www.hakahonu.cl/textil/hombre.html',
        button1: 'MUJER',
        button2: 'HOMBRE',
        class: 'c3-1'
    },
    {
        id: 2,
        nameh1: 'CALZADO',
        namep: 'LA HUELLA DE HAKA',
        url1: 'https://www.hakahonu.cl/mujeres/shoes.html',
        url2: 'https://www.hakahonu.cl/hombres/shoes.html',
        button1: 'MUJER',
        button2: 'HOMBRE',
        class: 'c3-2'
    }
];

export default dataCategories;